module.exports = __webpack_public_path__ + "static/pic04-d6b8309b87b9919a0678258b30f407d5.jpg";